import { getWeeksInMonth, startOfMonth, add, startOfWeek } from "date-fns";
import React from "react";

import { Box } from "@whoosh/design-system/src/components/primitive";

import { MonthHeader } from "./components/MonthHeader";
import { WeekRow } from "./components/WeekRow";
import { CalendarMonthProps } from "./types";

export const CalendarMonth = (props: CalendarMonthProps) => {
  const { monthDateObj, clubWeekStartsOn } = props;
  const startOfMonthDateObj = startOfMonth(monthDateObj);
  const nearestMondayToFirstOfMonthDateObj = startOfWeek(startOfMonthDateObj, {
    weekStartsOn: clubWeekStartsOn,
  });
  const weeksInMonth = getWeeksInMonth(monthDateObj, {
    weekStartsOn: clubWeekStartsOn,
  });
  return (
    <Box flex={1}>
      <MonthHeader
        monthDateObj={monthDateObj}
        clubWeekStartsOn={clubWeekStartsOn}
      />
      {Array(weeksInMonth)
        .fill(0)
        .map((_, i) => {
          const startDateObj =
            i === 0
              ? nearestMondayToFirstOfMonthDateObj
              : add(nearestMondayToFirstOfMonthDateObj, { weeks: i });
          return (
            <WeekRow key={`week${i}`} {...props} startDateObj={startDateObj} />
          );
        })}
    </Box>
  );
};
